<template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Adresse IP</th>
          <th scope="col">Pays</th>
          <th scope="col">Ville</th>
          <th scope="col">ISP</th>
          <th scope="col">Créé à</th>
          <th scope="col">Modifié à</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(allowedIP, index) in allowedIPs" :key="index++">
          <td class="text-center">
            {{ allowedIP.id }}
          </td>

          <td class="text-center">
            <code class="text-primary fw-bold">{{
              allowedIP.ip_address || allowedIP.ip
            }}</code>
          </td>

          <td class="">
            {{ allowedIP.country || "—" }}
          </td>

          <td class="">
            {{ allowedIP.city || "—" }}
          </td>

          <td class="">
            {{ allowedIP.isp || "—" }}
          </td>

          <td class="text-center">
            {{
              allowedIP.created_at
                ? new Date(allowedIP.created_at).toLocaleString("fr-FR")
                : "—"
            }}
          </td>

          <td class="text-center">
            {{
              allowedIP.updated_at
                ? new Date(allowedIP.updated_at).toLocaleString("fr-FR")
                : "—"
            }}
          </td>

          <td class="text-center">
            <button
              @click="remove(allowedIP)"
              class="btn btn-sm btn-danger"
              title="Supprimer cette IP"
            >
              <i class="bi bi-trash"></i>
              Supprimer
            </button>
          </td>
        </tr>
        <tr v-if="allowedIPs.length === 0">
          <td colspan="8" class="text-center text-muted">
            Aucune IP autorisée trouvée.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("allowedIp", {
      allowedIPs: "getAllowedIPs",
    }),
  },
  mounted() {
    this.$store.dispatch("allowedIp/getAll");
  },
  methods: {
    async refresh() {
      return await this.$store.dispatch("allowedIp/getAll");
    },

    async remove(allowedIP) {
      await this.$confirm({
        title: "Supprimer cette IP",
        message: `Voulez-vous supprimer l'IP ${
          allowedIP.ip_address || allowedIP.ip
        } ?`,
        button: {
          no: "Non",
          yes: "Oui",
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("allowedIp/destroy", allowedIP.id);
          }
        },
      });
    },
  },
};
</script>

<style scoped>
code {
  background-color: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.9rem;
}
</style>
